import React, { useEffect, useState } from 'react';
import '../../styles/download/main.css';
import { getAllCodeBooksandDownloads } from '../../Services/AllAPIs';
import LoadingSpinner from '../LoadingSpinner';

const Main = () => {

    const [loader, setLoader] = useState(true);
    const [download, setDownload] = useState([]);
    const [error, setError] = useState(null);

    // Fetch download data
    const getDownload = () => {
        getAllCodeBooksandDownloads()
            .then((res) => {
                // console.log('download--->', res.data.news);
                const downloadData = Object.values(res.data.news || {});
                setDownload(downloadData);
                setLoader(false);
            })
            .catch((error) => {
                setError("An error occurred while fetching download data.");
                setLoader(false);
            });
    };

    useEffect(() => {
        getDownload();
    }, []);


    // Function to format date as DD/MM/YYYY
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();

        return `${day}-${month}-${year}`;
    };

    return (
        <div id='downloadMain'>
            <div className="download-main">
                <div className="container mt-5 mb-5 admin-container">
                    <div className="row">

                        {loader && <LoadingSpinner />}
                        {error && <div className="error">{error}</div>}

                        <div className="col-md-12 pull-left flip sm-pull-none">
                            <div className="admin-table">
                                <h2 className="my-heading">Downloads</h2>
                                <div className="table-scrollable">
                                    <table className="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th>Title</th>
                                                <th>Posted Date</th>
                                                <th>Download</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {download.length > 0 ? (
                                                download.map((item, index) => (
                                                    <tr key={index}>
                                                        <td>{item.title}</td>
                                                        <td>{formatDate(item.created_at)}</td>
                                                        <td>
                                                            <a
                                                                href={item.url}
                                                                className="btn btn-primary btn-download"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="3">No data available</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Main;
